import React from 'react'
import { connect } from 'react-redux'

import { ModalHeader } from '../Modal'
import Pagination from '../Pagination'
import ColorButton from '../Controls/ColorButton'
import IconTable from '../IconTable'

import {
  closeIconPicker,
  openIconCreation,
} from '../../stores/pollBuilderIconPicker'

import { selectPositionOfNewExpertOpinion } from '../../stores/pollBuilderSelectedExpertOpinion'

import { setSelectedExpertOpinion } from '../../stores/pollBuilderSelectedExpertOpinion'

import { insertCheckedoutExpertOpinion } from '../../stores/pollBuilderCheckedoutExpertOpinions'

import { selectIsFetchingIcons } from '../../stores/pending'

import { selectIconsByQuery, parseIconsQuery } from '../../stores/iconsStore'

import {
  selectLocation,
  selectQuery,
  goToPreviousPage,
  goToNextPage,
  updateSearch,
} from '../../stores/routing'

const IconPicker = ({
  location,
  icons,
  query,
  isFetchingIcons,
  openIconCreation,
  goToNextPage,
  goToPreviousPage,
  updateSearch,
  closeIconPicker,
  positionOfNewExpertOpinion,
  setSelectedExpertOpinion,
  insertCheckedoutExpertOpinion,
}) => {
  function onIconClick(icon: Icon) {
    if (positionOfNewExpertOpinion == null) {
      throw new Error(
        'expected positionOfNewExpertOpinion to not be null when creating new expert opinion'
      )
    }
    const newExpertOpinion = {
      id: icon.id, //this will be replaced by the server
      text: '',
      name: icon.name,
      x: positionOfNewExpertOpinion.x,
      y: positionOfNewExpertOpinion.y,
      iconId: icon.id,
      icon,
    }
    setSelectedExpertOpinion(newExpertOpinion)
    closeIconPicker()
  }

  return (
    <div className="content">
      <ModalHeader title="Icon Library" close={closeIconPicker} />

      <IconTable
        location={location}
        items={icons}
        query={query}
        isFetching={isFetchingIcons}
        onClick={onIconClick}
        goToPreviousPage={() => goToPreviousPage(location)}
        goToNextPage={() => goToNextPage(location)}
        updateSearch={updateSearch}
      />

      <div className="bg-light-gray f7 ph4 pv3 items-center w-100 flex">
        <Pagination
          goToPreviousPage={() => goToPreviousPage(location)}
          goToNextPage={() => goToNextPage(location)}
          query={query}
          length={icons.length}
        />
        <div className="w-80 tr">
          <ColorButton
            colorClass="op-brand"
            borderClass="b--op-brand"
            onClick={openIconCreation}
          >
            Create new icon
          </ColorButton>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => {
  const query = selectQuery(state)
  const iconsQuery = parseIconsQuery(query)
  const icons = selectIconsByQuery(state, iconsQuery)

  return {
    location: selectLocation(state),
    icons,
    query: iconsQuery,
    isFetchingIcons: selectIsFetchingIcons(state),
    positionOfNewExpertOpinion: selectPositionOfNewExpertOpinion(state),
  }
}
const mapDispatchToProps = {
  insertCheckedoutExpertOpinion,
  openIconCreation,
  goToPreviousPage,
  goToNextPage,
  updateSearch,
  closeIconPicker,
  setSelectedExpertOpinion,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IconPicker)



// WEBPACK FOOTER //
// ./src/components/Snippets/IconPicker.js